import { Box, Heading, Icon, Modal, Paragraph } from '@zillow/constellation-10';
import { IconHideOutline } from '@zillow/constellation-icons';

import { PRODUCT_TYPE_NAME_TO_ID } from '../../../../constants/FreemiumConstants';
import ModalFooter from '../../../../components/modals/ModalFooter';

import type { UserPropertySummaryListingPaidInclusionProductWebDto } from '@zg-rentals/ts-rental-manager-api-client';

type Props = {
  onModalClose: () => void;
  onConfirmClick: () => void;
  activeProduct?: UserPropertySummaryListingPaidInclusionProductWebDto;
};

const ListingAvailabilityModal = ({ onModalClose, onConfirmClick, activeProduct }: Props) => {
  const isActiveProductTypePremium = activeProduct?.type === PRODUCT_TYPE_NAME_TO_ID.PREMIUM;

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onModalClose()}
      size={{ base: 'fullScreen', md: 'md' }}
      footer={
        <ModalFooter cancelText="Cancel" submitText="Confirm" onSubmit={onConfirmClick} onCancel={onModalClose} />
      }
      body={
        <Box css={{ paddingInline: '600' }}>
          <Box css={{ marginBottom: '600' }}>
            <Icon size="xl" css={{ color: 'icon.accent.blue.hero' }} render={<IconHideOutline />} />
          </Box>
          <Box css={{ marginBottom: '600' }}>
            <Heading level={4}>Confirm your listing&apos;s availability</Heading>
          </Box>
          <Box css={{ display: 'flex', flexDirection: 'column', gap: '400' }}>
            <Paragraph>Renters want to know that your property is still available to rent.</Paragraph>
            <Paragraph>
              Simply confirm your availability and your listing will stay active. We&apos;ll ask you to reconfirm in 7
              days.
            </Paragraph>
            <Paragraph>
              {`If you do not confirm availability, your listing will expire, but you can reactivate anytime. ${
                isActiveProductTypePremium
                  ? 'You’ll maintain access to your Premium benefits for 90 days since upgrade.'
                  : ''
              }`}
            </Paragraph>
          </Box>
        </Box>
      }
    />
  );
};

export default ListingAvailabilityModal;
